import {Easing} from "@tweenjs/tween.js";

// @ts-ignore
const easingArray: Array = Object.keys(Easing).map((key: any) => Object.keys(Easing[key]).map((innerKey: any) => {


    return {
        // @ts-ignore
        easing: Easing[key][innerKey],
        name: `Easing.${key}.${innerKey}`
    }
})).flat();

export default {
    easingArray
}
